export default __webpack_public_path__ + "static/media/sort_down.2ff9db1b.svg";